/** "—" for null, else a thousands-separated number. */
export function formatNum(value: number | null): string {
  return value === null ? '—' : value.toLocaleString();
}

/** "—" for null, else a one-decimal-place percentage (e.g. "41.7%"). */
export function formatPercent(value: number | null): string {
  return value === null ? '—' : `${value.toFixed(1)}%`;
}

/** "$1,234.56" — two-decimal USD with thousands separators. */
export function formatUsd(value: number): string {
  return `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** "R1 234,56" — two-decimal ZAR (en-ZA; separator is locale/ICU dependent). */
export function formatZar(value: number): string {
  return `R${value.toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** A FX-rate "last updated" timestamp → locale string; "" for null, the raw value if unparseable. */
export function formatRateTimestamp(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString();
}

/** Trello #202 — shared tooltip copy for the "Credits" column header (runs tables). */
export const CREDITS_TOOLTIP =
  'Token-weighted credits this run deducts (base credit × total tokens ÷ window). “—” for tools not on credit billing.';

/**
 * Trello #202 — a token-weighted credit charge: "—" for null/undefined
 * (non-credit-billed tool or no data), integers bare (e.g. "1", "5"), and
 * fractions trimmed to ≤2dp (e.g. "1.88", "0.75"). Non-finite → "—".
 */
export function formatCredits(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  if (Number.isInteger(value)) return String(value);
  return parseFloat(value.toFixed(2)).toString();
}
